import { IC3Api } from './ServiceImpl';

const IC3Service = (api: IC3Api) => {
    const getOrderCompany = async () => {
        const response = await api.getOrderCompany();
        return response?.data;
    };

    return {
        getOrderCompany,
    };
};

export default IC3Service;
